import React, { PureComponent } from 'react';
import styled from 'styled-components';

class Logo extends PureComponent {

  constructor() {
    super();
    this.logo = React.createRef();
  }

  componentDidMount() {
    this.logoTL = new TimelineMax({ paused: true });

    const drip = this.logo.current.querySelector('.logo-drip');
    const drop = this.logo.current.querySelector('.logo-drop');
    const [drop1, drop2, drop3] = drop.children;

    this.logoTL
      .fromTo(drip, 0.6, { y: 0, ease: Power3.easeIn }, { y: 105, ease: Power3.easeIn })
      .to(drip, 0.1, { scaleX: 2, scaleY: 0.5, transformOrigin: '50% 100%' }, '-=.1')
      .set(drip, { opacity: 0 })
      .set(drop, { opacity: 1 })
      .add('droping')
      .to(drop1, 0.2, { y: -30, ease: SlowMo.ease.config(0.1, 1, true) }, 'droping')
      .to(drop2, 0.3, { y: -35, ease: SlowMo.ease.config(0.1, 1, true) }, 'droping')
      .to(drop3, 0.4, { y: -90, ease: SlowMo.ease.config(0.1, 1, true) }, 'droping')
      .to(drop1, 0.2, { x: -40, transformOrigin: '50% 50%', ease: Power0.easeNone }, 'droping')
      .to(drop2, 0.3, { x: 30, transformOrigin: '50% 50%', ease: Power0.easeNone }, 'droping')
      .to(drop3, 0.4, { x: 20, ease: Power0.easeNone }, 'droping')
      .to(drop1, 0.1, { scale: 0, ease: Power3.easeIn }, 'droping+=.1')
      .to(drop2, 0.1, { scale: 0, ease: Power3.easeIn }, 'droping+=.2')
      .to(drop3, 0.1, { scale: 0, ease: Power3.easeIn }, 'droping+=.3')
      .set(drip, { opacity: 1, scaleX: 0.8, scaleY: 1, transformOrigin: '50% 100%', y: -40 })
      .to(drip, 0.4, { opacity: 1, scale: 1, y: 0, ease: Power2.easeOut });
  }

  logoHover = () => {
    if (this.logoTL.progress() === 0 || this.logoTL.progress() === 1) {
      this.logoTL.play(0);
    }
  }

  componentWillUnmount() {
    this.logoTL.kill();
  }

  render() {
    return (
      <LogoSVG ref={this.logo} onMouseEnter={this.logoHover} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 629 218.8">
        <g>
          <path d="M96.5 180.6l-17.9-54.3H59.3l-17.9 54.3-16.5-54H0l.9 2.7L31 218.1h19.6l18.1-52.5 18.1 52.5h19.6l31-91.5h-24.3z" />
          <path d="M316.6 126.6l-16.5 54-17.9-54.3h-19.4l-17.9 54.3-16.5-54h-24.9l1 2.7 30.1 88.8h19.6l18.1-52.5 18.1 52.5h19.5l31.1-91.5z" />
          <path className="logo-drip" d="M153.2 198c0 9.6 7.8 17.4 17.4 17.4 9.6 0 17.4-7.8 17.4-17.4.3-14.8-17.4-20.9-17.4-35 0 14.2-17.4 19.4-17.4 35z" />
          <g className="logo-drop" opacity="0">
            <circle className="logo-drop-1" cx="166" cy="310" r="10" />
            <circle className="logo-drop-2" cx="176" cy="310" r="10" />
            <circle className="logo-drop-3" cx="171" cy="310" r="10" />
          </g>
        </g>
        <path d="M427.6 49.5c1.2 4.7 1.6 7.3 1.7 7.7.7-3.3 1.2-5.9 1.6-7.7l6.2-24.9h14.4L436.7 77h-13.3L417 54.6c-.4-1.3-1-3.7-1.8-7-.7 2.7-1.2 5.1-1.8 7L407 77h-13.3L379 24.5h14.4l6 25.1c.7 2.6 1.2 5.3 1.6 7.8.5-2.7 1.2-5.4 1.8-7.8l6.6-25.1H421l6.6 25z" />
        <path d="M464 24.5h17.9L500 77h-14.2l-2.6-9.4h-20.3l-2.7 9.4H446l18-52.5zm16.1 32.9l-5.4-17.3c-.2-.8-.8-3.2-1.8-7-1 3.9-1.6 6.2-1.8 7l-5.3 17.3h14.3z" />
        <path d="M493.7 24.5h15.2l10.5 29.3c.2.6.8 2.9 1.8 7 1-4.1 1.6-6.5 1.8-7l10.4-29.3h15.2l-22 52.4h-10.9l-22-52.4z" />
        <path d="M552.8 24.5h32.1V36h-18.2v9.1h17.2v11.2h-17.2v8.9h18.2V77h-32.1V24.5z" />
        <path d="M609.2 67.2c4 0 6.5-2.3 6.5-5.4 0-4.2-2.9-5.4-8.8-7-9.5-2.5-14.1-6.3-14.1-14.5 0-9.8 7.1-17 18.1-17 5.9 0 11 1.5 15.5 4.7L622 38.2c-3.3-2.8-6.8-4.2-10-4.2-3.5 0-5.8 1.9-5.8 4.4 0 3.7 3.6 4.5 8.4 5.8 9.3 2.5 14.4 5.9 14.4 15.6 0 10.9-7.8 18.5-20.1 18.5-7.4 0-13-2.3-18.6-7.7l6.5-10.6c4.1 4.8 8.2 7.2 12.4 7.2z" />
        <path d="M385.3 95.7h32.1v11.5h-18.2v9.1h17.2v11.2h-17.2v20.6h-13.9V95.7z" />
        <path d="M467.9 141.5c-5.4 5.2-12.5 8.1-19.9 8.1-6.4 0-12.8-2.3-17.8-6.3-6.6-5.3-10.2-12.8-10.2-21.2 0-7.5 2.9-14.2 8.2-19.4 5.3-5.1 12.5-8.1 19.8-8.1 7.3 0 14.6 2.9 19.9 8.1 5.3 5.2 8.1 12 8.1 19.4 0 7.4-2.9 14.3-8.1 19.4zm-6.2-19.4c0-8.5-5.7-15.4-13.7-15.4-8.1 0-13.7 6.8-13.7 15.4 0 8.7 5.4 15.4 13.7 15.4 8.1 0 13.7-6.9 13.7-15.4z" />
        <path d="M481.9 95.7h15.9c7.3 0 12.8.1 17.3 3.5 3.8 2.9 5.9 7.4 5.9 12.8 0 8.1-4.1 13.3-11.7 15l14.3 21.1h-16.1l-12-20.5v20.5h-13.4V95.7zm16.1 24.8c6 0 8.9-1.9 8.9-6.5 0-5.5-2.7-7.3-8.7-7.3h-2.9v13.8h2.7z" />
        <path d="M427.6 191.3c1.2 4.7 1.6 7.3 1.7 7.7.7-3.3 1.2-5.9 1.6-7.7l6.2-24.9h14.4l-14.8 52.4h-13.3l-6.5-22.4c-.4-1.3-1-3.7-1.8-7-.7 2.7-1.2 5.1-1.8 7l-6.4 22.4h-13.3L379 166.3h14.4l6 25.1c.7 2.6 1.2 5.3 1.6 7.8.5-2.7 1.2-5.4 1.8-7.8l6.6-25.1H421l6.6 25z" />
        <path d="M464 166.3h17.9l18.1 52.4h-14.2l-2.6-9.4h-20.3l-2.7 9.4H446l18-52.4zm16.1 32.9l-5.4-17.3c-.2-.8-.8-3.2-1.8-7-1 3.9-1.6 6.2-1.8 7l-5.3 17.3h14.3z" />
        <path d="M506.5 178.7h-11.7v-12.4h37.7v12.4h-11.7v40h-14.3v-40z" />
        <path d="M539.5 166.3h32.1v11.5h-18.2v9.1h17.2v11.2h-17.2v8.9h18.2v11.7h-32.1v-52.4z" />
        <path d="M581.1 166.3H597c7.3 0 12.8.1 17.3 3.5 3.8 2.9 5.9 7.4 5.9 12.8 0 8.1-4.1 13.3-11.7 15l14.3 21.1h-16.1l-12-20.5v20.5h-13.4v-52.4zm16 24.8c6 0 8.9-1.9 8.9-6.5 0-5.5-2.7-7.3-8.7-7.3h-2.9v13.8h2.7z" />
        <path d="M245.7 22.3c-23.8 0-43.2 19.4-43.2 43.2v1.8h24.7v-1.8c0-10.2 8.3-18.5 18.5-18.5s18.5 8.3 18.5 18.5S255.9 84 245.7 84l-60.7.2V0h-25.5L84.1 87.3v21.4h72l.1 41H185l-.1-41 60.7.1c23.8 0 43.2-19.4 43.2-43.2s-19.3-43.3-43.1-43.3zm-89.6 61.9h-36.5l36.5-42.8v42.8z" />
      </LogoSVG>
    );
  }
}

const LogoSVG = styled.svg`
  display: block;
  fill: currentColor;
  overflow: visible;
`;

export default Logo;
